module.exports = __webpack_public_path__ + "static/what-got-you-here-wont-get-you-there-9c8ada26ede22f7f1d3c2bfe370ff530.jpg";